

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache, setUserDetails } from '../../General/Actions.js';
import avatar from '../../ImageAssets/avatarForUserDetailsCard.png';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import GeneralUtils from '../../Utils/generalUtils.js';
import { FaLandmark, FaPencilAlt } from "react-icons/fa";
import SliderModal from '../../Utils/sliderModal.js';
import ValidateForm from '../../Utils/formValidation';
import closeIcon from '../../ImageAssets/closeViewIcon.png'
import viewIcon from '../../ImageAssets/viewIcon.png';
import infoIcon from '../../ImageAssets/infoIcon.png';
import { Modal, ModalBody, Collapse, Tooltip, CardBody, Card, Input, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import "react-toggle/style.css";
import Toggle from 'react-toggle';

class AccountSettingComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentActiveSubMenu: "OVERVIEW",
            isFloatingSubMenuVisible: false,
            currentTab: "bundles",
            villageDetails: [],
            countryDetails: [],
            parishDetails: [],
            notificationEmailId: "",
            notificationSMSNumber: "",
            isSlderModalVisible: false,
            sliderModalHeading: "", 
            type: "",
            isBillingAddressValidationModalVisible: false,
            newPasswordhidden: true,
            isPasswordInfoTooltipOpen: false,
            changePasswordModal_newPassword: "",
            changePasswordModal_confirmPassword: "",
            changePasswordModal_oldPassword: "",
            itemisedBillDropdownOpen: false,
            summaryBillDropdownOpen: false,
            isSummaryBillEnabled: false,
            isBillingPreferenceChanged: false,
            selectedPreferenceForSummaryBill: "",
            selectedPreferenceForItemisedBill: "",
            billingPreferenceEmailId: "",
            voiceMailStatusLabel: "Voicemail Enabled",
            notificationVoiceStatus: false,
            currentAddress2: "",
            billSMSNumber: "",
            balanceTransferAllowed: false,
            callMeBackAllowed: false,
            creditRequestAllowed: false,
            serviceName: "",
            enableVasFeatures: "false"
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        this.setState({ seconds: seconds });
        var element = document.getElementById("timer")
        if (typeof (element) != 'undefined' && element != null) {
            element.innerHTML = this.secondsToTime(seconds).m + ":" + this.secondsToTime(seconds).s + "s"
        }
        if (seconds == 0) {
            this.setState({ isOtpTimerEnds: true })
            clearInterval(this.timer);
        }
    }


    componentDidMount() {
          //handle vas feature config
          var enableVasFeatures = "false";
          if (this.props.configurationValues && this.props.configurationValues.enableVasFeatures) {
              enableVasFeatures = this.props.configurationValues.enableVasFeatures
          }
  
        this.initializeSettingsRoot(); // for getting data when clicking the menu
        this.setState({enableVasFeatures: enableVasFeatures, isLoading: true })
        window.addEventListener('scroll', this.handleScroll);
        var serviceId = "";
        if(this.props.cache.serviceInfo && this.props.cache.serviceInfo.serviceId)
            serviceId = this.props.cache.serviceInfo.serviceId;
        Network.executeAxios("fetchHlrStatus", "POST", {"serviceId": serviceId} , (HLRstatusResponse) => {
            this.manageHlrStatus(HLRstatusResponse);
        Network.executeAxios("fetchCcmConfig", "POST", { "keyword": "Village" }, (villageResponse) => {
            Network.executeAxios("fetchCcmConfig", "POST", { "keyword": "Parish" }, (parishResponse) => {
                Network.executeAxios("fetchCcmConfig", "POST", { "keyword": "Country" }, (countryResponse) => {
                    this.populateAddressDetails(villageResponse, parishResponse, countryResponse);
                })
            })
        })
    })
    }

    manageHlrStatus(receivedResponse, isLoadingChangeReq){

        var notificationVoice = false;
        var voiceMailStatusLabel = "Voicemail Enabled"
        if(receivedResponse && receivedResponse.responseData){
            var receivedDataFromRes = receivedResponse.responseData;
            if(receivedDataFromRes["CFNRY"] === "true" && receivedDataFromRes["CFB"] === "true" && receivedDataFromRes["CFNRC"] === "true"){
                notificationVoice = true;
                voiceMailStatusLabel= "Voicemail Enabled"
            } else {
                notificationVoice = false;
                voiceMailStatusLabel= "Voicemail Disabled"
            }
           
           this.setState({voiceMailStatusLabel: voiceMailStatusLabel, notificationVoiceStatus: notificationVoice})
           
            if(isLoadingChangeReq) this.setState({isLoading: false})
        }
    }




    populateAddressDetails(villageResponse, parishResponse, countryResponse) {

        var villageArr = [];
        var parishArr = [];
        var countryArr = [];
        if (villageResponse && villageResponse.content && villageResponse.content[0]) {
            var currentVillageArr = villageResponse.content
            for (var i = 0; i < currentVillageArr.length; i++) {
                var temp = {
                    "id": currentVillageArr[i].configId,
                    "value": currentVillageArr[i].configValue
                }
                villageArr.push(temp)
            }
            villageArr.sort((a, b) => a.value.localeCompare(b.value));
        }
        if (parishResponse && parishResponse.content && parishResponse.content[0]) {
            var currentParishArr = parishResponse.content
            for (var j = 0; j < currentParishArr.length; j++) {
                var temp = {
                    "id": currentParishArr[j].configId,
                    "value": currentParishArr[j].configValue
                }
                parishArr.push(temp)
            }
            parishArr.sort((a, b) => a.value.localeCompare(b.value));
        }
        if (countryResponse && countryResponse.content && countryResponse.content[0]) {
            var currentCountryArr = countryResponse.content
            for (var k = 0; k < currentCountryArr.length; k++) {
                var temp = {
                    "id": currentCountryArr[k].configId,
                    "value": currentCountryArr[k].configValue
                }
                countryArr.push(temp)
            }
            countryArr.sort((a, b) => a.value.localeCompare(b.value));
        }

        this.setState({
            villageDetails: villageArr,
            parishDetails: parishArr,
            countryDetails: countryArr,
            isLoading: false
        })
    }

    initialize = () => {
        Network.executeAxios("querySubscriber", "POST", {}, (querySubscriberResponse) => {
            this.props.setCache("querySubscriberResponse", querySubscriberResponse);
            Network.executeAxios("fetchServiceInfo", "POST", {}, (fetchServiceInfoResponse) => {
                var serviceListResponse = [];
                try {
                    serviceListResponse = fetchServiceInfoResponse.BillingSystem.response.dataset.service_info;
                } catch (err) {
                    serviceListResponse = [];
                }
                this.props.setCache("serviceListResponse", serviceListResponse);
                Network.executeAxios("fetchAccountDetails", "POST", {}, (fetchAccountDetailsResponse) => {
                    this.props.setCache("fetchAccountDetailsResponse", fetchAccountDetailsResponse);
                    this.initializeSettingsRoot();
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 1000);
                });
            });
        });
    }

    billingAddressModalClicked(type) {
        if (type === "cancel") {
            if (this.state.isOtpTimerEnds) { this.timer = 0 }
            this.setState({ isBillingAddressValidationModalVisible: false, billingAddress_otp: "", isOtpTimerEnds: false })
        } else if (type === "submit") {
            if (this.props.userDetails.generatedOtp == this.state.billingAddress_otp) {
                var billingAddressChange = {
                    addressLine1: this.state.changeBillingAddressLine1,
                    addressLine2: this.state.changeBillingAddressLine2,
                    city: this.state.changeBillingCity,
                    state: this.state.changeBillingState,
                    address_id: this.state.addressId,
                    accountId: this.state.accountId,
                    contactName: this.state.accountFullName,
                    contactNum: this.state.contactNumber
                }

                this.setState({ isBillingAddressValidationModalVisible: false, isOtpTimerEnds: false })
                this.setState({ isLoading: true })
                Network.executeAxios("billingAddressChange", "POST", { billingAddressChange }, (response) => {
                    this.setState({ isLoading: false });
                    var isSuccess = false;
                    try {
                        if (response.result_code === "0") {
                            isSuccess = true;
                        }
                    } catch (err) { isSuccess = false }
                    if (isSuccess) {
                        this.setState({ isEditBillingAddressCollapseOpen: false });
                        Swal.fire({
                            title: this.props.locales.SettingsCompBillAddressChangedSwal,
                            text: '',
                            type: '',
                            showCancelButton: false,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.setState({ seconds: 60, billingAddress_otp: "", isLoading: true })
                                this.initializeSettingsRoot();
                            }
                        });
                    } else {
                        Swal.fire(this.props.locales.SettingsCompBillAddressChangedFailSwal, "", "");
                    }
                });
            } else {
                Swal.fire(this.props.locales.RegisterOtpNtMatchingSwal, "", "");
            }
        } else if (type === "resendOtp") {
            this.timer = 0;
            this.setState({ resendOtpClicked: true })
            this.callOtpAuth();
        }
    }

    callOtpAuth() {
        this.setState({ seconds: 60 })
        this.props.setUserDetails("generatedOtp", "");
        var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
        var contactNumber = this.state.billSMSNumber;
        contactNumber = contactNumber.replace(/\D/g, "");
        var dataToSendForOtp = {
            otp: generatedOtp,
            contactNum: contactNumber,
            type: "billAddressChange"
        }
        this.setState({ isLoading: true })
        Network.executeAxios("otpAuth", "POST", dataToSendForOtp, (responseForOtp) => {
            this.setState({ isLoading: false })
            if (responseForOtp.result_code && responseForOtp.result_code === "0") {
                this.props.setUserDetails("generatedOtp", generatedOtp);
                this.setState({ isOtpTimerEnds: false, isBillingAddressValidationModalVisible: true, seconds: 60 })
                this.startTimer();
            } else {
                Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
            }
        });
    }


    initializeSettingsRoot() {
        Network.executeAxios("querySubscriber", "POST", {}, (querySubscriberResponse) => {
            try {
                var receivedResponse = querySubscriberResponse;
                var params = receivedResponse.profile_info.basic_details;
                var firstName = "";
                var lastName = "";
                var finalContactNumber = "";
                var finalEmailId = "";
                var finalProfileId = "";
                var finalPin = "";
                for (var i = 0; i < params.length; i++) {
                    if (params[i].id === "first_name") {
                        firstName = params[i].value;
                    }
                    if (params[i].id === "last_name") {
                        lastName = params[i].value;
                    }
                    if (params[i].id === "contact_number_1") {
                        finalContactNumber = params[i].value;
                    }
                    if (params[i].id === "contact_email_id") {
                        finalEmailId = params[i].value;
                    }
                    if (params[i].id === "profile_id") {
                        finalProfileId = params[i].value;
                    }
                }
                this.setState({
                    billingName: firstName + " " + lastName,
                    contactNumber: GeneralUtils.formatPhoneNumberToUsFormatNew(finalContactNumber),
                    contactEmailId: finalEmailId,
                    profileId: finalProfileId
                });
            } catch (Exception) {
            }
            try {
                var accountInfo = querySubscriberResponse;
                var accountInfoParams = accountInfo.account_info.basic_details;
                var finalAccountId = "";
                var finalNotificationEmailId = "";
                var finalSMSNumber = "";
                var finalNotificationVoiceNumber = "";
                var finalNotificationEmailStatus = "";
                var finalNotificationSMSStatus = "";
                var finalNotificationVoiceStatus = "";
                var accountFirstName = "";
                var accountLastName = "";
                var billSMSNumber = "";
                for (var i = 0; i < accountInfoParams.length; i++) {
                    if (accountInfoParams[i].id === "account_id") {
                        finalAccountId = accountInfoParams[i].value;
                    }
                    if (accountInfoParams[i].id == "billing_name") {
                        accountFirstName = accountInfoParams[i].value;
                    }
                    if (accountInfoParams[i].id == "last_name") {
                        accountLastName = accountInfoParams[i].value;
                    }

                    if (accountInfoParams[i].id === "notification_email_id") {
                        finalNotificationEmailId = accountInfoParams[i].value;
                    }
                    if (accountInfoParams[i].id === "sms_numbers") {
                        finalSMSNumber = accountInfoParams[i].value;
                        billSMSNumber = accountInfoParams[i].value;
                    }

                    if (accountInfoParams[i].id === "ivr_number") {
                        finalNotificationVoiceNumber = accountInfoParams[i].value;
                    }
                    if (accountInfoParams[i].id === "email_notification") {
                        finalNotificationEmailStatus = accountInfoParams[i].value;
                    }
                    if (accountInfoParams[i].id === "sms_notification") {
                        finalNotificationSMSStatus = accountInfoParams[i].value;
                    }
                    if (accountInfoParams[i].id === "ivr_notification") {
                        finalNotificationVoiceStatus = accountInfoParams[i].value;
                    }
                }

                if (finalNotificationEmailStatus === "0") {
                    finalNotificationEmailStatus = false;
                } else {
                    finalNotificationEmailStatus = true;
                }
                if (finalNotificationSMSStatus === "0") {
                    finalNotificationSMSStatus = false;
                } else {
                    finalNotificationSMSStatus = true;
                }
                if (finalNotificationVoiceStatus === "0") {
                    finalNotificationVoiceStatus = false;
                } else {
                    finalNotificationVoiceStatus = true;
                }





                if (finalSMSNumber !== "") {
                    finalSMSNumber = GeneralUtils.formatPhoneNumberToUsFormatNew(finalSMSNumber)
                } else {
                    finalSMSNumber = "NA"
                }
                this.setState({
                    billSMSNumber: billSMSNumber,
                    accountId: finalAccountId,
                    accountFullName: accountFirstName + " " + accountLastName,
                    accountFirstName: accountFirstName,
                    notificationEmailId: finalNotificationEmailId,
                    notificationSMSNumber: finalSMSNumber,
                    notificationVoiceNumber: GeneralUtils.formatPhoneNumberToUsFormatNew(finalNotificationVoiceNumber),
                    notificationEmail: finalNotificationEmailStatus,
                    notificationSMS: finalNotificationSMSStatus,
                    notificationVoice: finalNotificationVoiceStatus
                });
            } catch (err) {
            }
            Network.executeAxios("fetchAccountDetails", "POST", {}, (fetchAccountDetailsResponse) => {
                this.setState({ isLoading: false });
                var preferenceForSummaryBill = "";
                var preferenceForItemisedBill = "";
                var isSummaryBillSelected = false;
                var billingPreferenceEmailId = "";
                try {
                    var FetchAccountDetail = fetchAccountDetailsResponse;
                    var billingAddress = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].addresses[0];
                    var summaryBillDispatch = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].summary_dispatch;
                    var itemisedBillDispatch = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].itemized_dispatch;
                    var itemizedRequired = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].itemized_required;  //if 0 - summary if 1 - itemised
                    var billingAddressLine1 = "";
                    var billingAddressLine2 = "";
                    var addressLine3 = "";
                    var addressLine4 = "";
                    var addressLine5 = "";
                    var address_id = "";
                    billingAddressLine1 = billingAddress.addr_line1;
                    billingAddressLine2 = billingAddress.addr_line2;
                    addressLine3 = billingAddress.addr_line3;
                    addressLine4 = billingAddress.addr_line4;
                    addressLine5 = billingAddress.addr_line5;
                    address_id = billingAddress.address_id;

                    if (itemizedRequired == "0") {  // summary
                        isSummaryBillSelected = true;
                        if (summaryBillDispatch == "1") {
                            preferenceForSummaryBill = "Email"
                            billingPreferenceEmailId = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].notification_email_id;
                        } else if (summaryBillDispatch == "2") {
                            preferenceForSummaryBill = "Postal"
                        } else if (summaryBillDispatch == "3") {
                            billingPreferenceEmailId = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].notification_email_id;
                            preferenceForSummaryBill = "Both"
                        }
                    } else { // itemized
                        if (itemisedBillDispatch == "1") {
                            preferenceForItemisedBill = "Email"
                            billingPreferenceEmailId = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].notification_email_id;
                        } else if (itemisedBillDispatch == "2") {
                            preferenceForItemisedBill = "Postal"
                        }
                    }

                    this.setState({
                        currentAddress1: billingAddressLine1,
                        currentAddress2: billingAddressLine2,
                        currentState: addressLine4,
                        currentCity: addressLine3,
                        billingAddressLine1: billingAddressLine1,
                        changeBillingAddressLine1: billingAddressLine1,
                        billingAddressLine2: billingAddressLine2,
                        state: addressLine4,
                        city: addressLine3,
                        addressId: address_id,
                        selectedPreferenceForSummaryBill: preferenceForSummaryBill,
                        selectedPreferenceForItemisedBill: preferenceForItemisedBill,
                        isSummaryBillEnabled: isSummaryBillSelected,
                        billingPreferenceEmailId: billingPreferenceEmailId,
                        isBillingPreferenceChanged: false
                    })

                }
                catch (err) {
                }
            })
        })
    }


    handleScroll = (event) => {
        if (window.scrollY > 190) {
            this.setState({ isFloatingSubMenuVisible: true });
        } else {
            this.setState({ isFloatingSubMenuVisible: false });
        }
    }

    generalBtnClicked(type){
        var mainHeading = "";
        if(type === "changeEmail"){
            mainHeading = "Change Email Address"
        } else if(type === "changeContactNum"){
            mainHeading = "Change Contact Number"
        } else if(type === "billingAddress"){
            this.setState({changeBillingAddressLine1: this.state.currentAddress1, changeBillingAddressLine2: this.state.currentAddress2, changeBillingCity: this.state.currentCity, changeBillingState: this.state.currentState})
            mainHeading = "Change Billing Address"
        } else if(type === "changePassword"){
            mainHeading = "Change Password"
        } else if(type === "changeBillingPref"){
            mainHeading = "Change Billing Preferences"
        } 
        if(type === "billingAddress" && this.state.billSMSNumber === "")
            Swal.fire(this.props.locales.addContactNumSwalMsg)
        else
        this.setState({changeNotificationEmailId: this.state.notificationEmailId, changeNotificationSMSNumber: this.state.notificationSMSNumber, sliderModalHeading: mainHeading, type: type, isSlderModalVisible: true})
    }

    manageVasFeaturesClicked(type){
        var mainHeading = this.props.locales.manageVasFeatureMainHeading;
        var creditRequestAllowed = false;
        var balanceTransferAllowed = false;
        var callMeBackAllowed = false;
        var serviceName = "";
         this.setState({isLoading: true})
         Network.executeAxios("fetchSubscriberInfo", "POST", {"serviceId": this.props.cache.serviceInfo.serviceId} , (fetchSubscriberInfoResponse) => {
            try {
                var params = fetchSubscriberInfoResponse.service_info.basic_details;
                for(var i=0; i<params.length; i++){
                    if (params[i].id === "callMeBackAllowed" && params[i].value && params[i].value === "true") {
                        callMeBackAllowed =true;
                    }
                    if (params[i].id === "creditRequestAllowed" && params[i].value && params[i].value === "true") {
                        creditRequestAllowed =true;
                    }
                    if (params[i].id === "balanceTransferAllowed" && params[i].value && params[i].value === "true") {
                        balanceTransferAllowed =true;
                    }
                    if (params[i].id === "service_name") {
                        serviceName =params[i].value;
                    }
                } 
            } catch(err){
                console.log("error in fetch subscriber info")
            }
            this.setState({serviceName: serviceName, creditRequestAllowed: creditRequestAllowed, balanceTransferAllowed: balanceTransferAllowed, callMeBackAllowed: callMeBackAllowed, sliderModalHeading: mainHeading, type: type, isSlderModalVisible: true, isLoading: false})
         })
       
    }

    handleInputValueChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.state[name] = value;
        this.setState({ dummy: "dummy" });
    };


    subMenuClicked = (type,receivedServiceId,serviceAddress,isAddFnFAddon) => {
        this.setState({ currentActiveSubMenu: type,serviceId:receivedServiceId, serviceAddress:serviceAddress, isAddFnFAddon: isAddFnFAddon});
        // if (window.scrollY > 0) {
        //     window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        //     setTimeout(() => {
        //         this.setState({ currentActiveSubMenu: type });
        //     }, 500);
        // } else {
        //     this.setState({ currentActiveSubMenu: type });
        // }
    }

    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center">
                <div id="AccountSettingsComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : this.renderChangePlanContentPart()}
                </div>
            </div>
        );
    }

    renderChangePlanContentPart() {
        return <div className='col-md-12 m-0 p-0 d-flex justify-content-center' style={{flex: 1}}>
           
            {/* <div className='cardOuterContainer col-md-8 m-0' style={{ maxHeight:(window.innerHeight - 350 )+"px"}}> */}
                {this.userDetailsCard()}
            {/* </div> */}
        </div>
    }

    sliderModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            this.setState({ isSlderModalVisible: false })
        } else if(dataObject.type === "submit"){
            if (this.state.type === "billingAddress") {
                this.setState({ resendOtpClicked: false })
                if (this.state.changeBillingAddressLine1 === this.state.billingAddressLine1 && this.state.changeBillingAddressLine2 === this.state.billingAddressLine2 &&
                    this.state.changeBillingCity === this.state.city && this.state.changeBillingState === this.state.state) {
                    Swal.fire(this.props.locales.billingAddressUpdateInSwal, "", "")
                } else {
                    if (ValidateForm.inputFieldMandatoryCheck("billingAddressContainer", this.props.locales, false)) {
                        if (ValidateForm.inputFieldValueCompositionCheck("billingAddressContainer", this.props.locales, false)) {
                            this.setState({isSlderModalVisible: false})
                            this.callOtpAuth();
                        }
                    }
                }
            } else if (this.state.type === "changeEmail") {
                if (ValidateForm.inputFieldMandatoryCheck("changeEmailContainer", this.props.locales, false)) {
                    if (ValidateForm.inputFieldValueCompositionCheck("changeEmailContainer", this.props.locales, false)) {
                        const dataToSend = {
                            notificationEmailId: this.state.changeNotificationEmailId,
                            accountId: this.state.accountId
                        };
                        this.setState({ isLoading: true })
                        Network.executeAxios("updateAccount", "POST", dataToSend, (response) => {
                            this.setState({ isLoading: false });
                            var isSuccess = false;
                            try {
                                if (response.result_code === "0") {
                                    isSuccess = true;
                                }
                            } catch (err) { }
                            if (isSuccess) {
                                this.setState({ isEditEmailCollapseOpen: false });
                                Swal.fire({
                                    title: this.props.locales.emailAddressUpdatedInSwal,
                                    text: "",
                                    type: '',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.setState({ isLoading: true, isSlderModalVisible: false })
                                        this.initializeSettingsRoot();
                                    }
                                });
                            } else {
                                Swal.fire(this.props.locales.emailAdressUpdationFailedInSwal, "", "");
                            }
                        });
    
                    }
                }
            } else if (this.state.type === "changeContactNum") {
                if (ValidateForm.inputFieldMandatoryCheck("changeSMSNumberContainer", this.props.locales, false)) {
                    if (ValidateForm.inputFieldValueCompositionCheck("changeSMSNumberContainer", this.props.locales, false)) {
                        const dataToSend = {
                            notificationSMSNumber: this.state.changeNotificationSMSNumber,
                            accountId: this.state.accountId
                        };
                        this.setState({ isLoading: true })
                        Network.executeAxios("updateAccount", "POST", dataToSend, (response) => {
                            this.setState({ isLoading: false });
                            var isSuccess = false;
                            try {
                                if (response.result_code === "0") {
                                    isSuccess = true;
                                }
                            } catch (err) { }
                            if (isSuccess) {
                                this.setState({ isEditContactNumCollapseOpen: false });
                                Swal.fire({
                                    title: this.props.locales.contactNumberUpdatedInSwal,
                                    text: "",
                                    type: '',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.setState({ isLoading: true,  isSlderModalVisible: false })
                                        this.initializeSettingsRoot();
                                    }
                                });
                            } else {
                                Swal.fire(this.props.locales.contactNumberUpdationFailedInSwal, "");
                            }
                        });
                    }
                }
            } else if(this.state.type === "changePassword"){
                if (this.state.changePasswordModal_newPassword !== "" && this.state.changePasswordModal_newPassword != null ) {
                    if (ValidateForm.inputFieldMandatoryCheck("changePasswordModalContainer", this.props.locales)) {
                        if (ValidateForm.inputFieldValueCompositionCheck("changePasswordModalContainer", this.props.locales)) {
                            if (this.state.changePasswordModal_newPassword === this.state.changePasswordModal_confirmPassword) {
                                const newPassword = this.state.changePasswordModal_newPassword;
                                const dataToSend = {
                                    newPassword: newPassword,
                                    currentPassword: this.state.changePasswordModal_oldPassword
                                };
                                Network.executeAxios("changePassword", "POST", dataToSend, (response) => {
                                    if (response.STATUS === "SUCCESS") {
                                        Swal.fire({
                                            title: this.props.locales.SettingsCompPswChangedSuccessFullySwal,
                                            text: this.props.locales.pleaseLoginAgainMsgInSwal,
                                            type: '',
                                            showCancelButton: false,
                                            confirmButtonText: 'OK'
                                        }).then((result) => {
                                            if (result.value) {
                                                Network.executeAxios("logout", "GET", {}, (response) => {
                                                    if (response.STATUS === "SUCCESS") {
                                                        localStorage.removeItem("isUserLoggedIn");
                                                        localStorage.removeItem("uniqueToken");
                                                        localStorage.removeItem("currentAccount");
                                                        localStorage.removeItem("currentService");
                                                        localStorage.removeItem("isSignInOptionClickedForMobile");
                                                        if (localStorage.getItem("isMobile")) {
                                                            localStorage.setItem("isSignInOptionClickedForMobile", true)
                                                            window.location.replace('/mobile=true&mobileNumber=' + this.state.phoneNumber);
                                                        } else {
                                                            localStorage.removeItem("isMobile");
                                                            window.location.replace('/');
                                                        }
        
                                                    } else {
                                                        Swal.fire(this.props.locales.logoutFailedTitleInSwal, "", "");
                                                    }
                                                });
                                            }
                                        });
                                    } else if (response.STATUS === "INCORRECT_OLD_PASSWORD") {
                                        Swal.fire(this.props.locales.SettingsCompPlseEnterCrtPswSwal, "", "");
                                    } else {
                                        Swal.fire(this.props.locales.SettingsCompPswChangedFailedSwal, "", "");
                                    }
                                });
                            } else {
                                Swal.fire(this.props.locales.SettingsCompPswDoNtMatchSwal, "", "");
                            }
                        }
                    }
                }
            } else if(this.state.type === "changeBillingPref"){
                var selectedPreferenceForItemisedBill = this.state.selectedPreferenceForItemisedBill;
                var selectedPreferenceForSummaryBill = this.state.selectedPreferenceForSummaryBill;
                if (selectedPreferenceForItemisedBill || selectedPreferenceForSummaryBill) {
                    Swal.fire({
                        title: this.props.locales.billingPreferencesChangeText,
                        text: "",
                        type: '',
                        showCancelButton: true,
                        confirmButtonText: this.props.locales.okButtonTextInSwal,
                        cancelButtonText: this.props.locales.cancelButtonTextInSwal,
                        reverseButtons: true
                    }).then((result) => {
                        if (result.value) {
                            if (this.state.isSummaryBillEnabled) {
                                if (selectedPreferenceForSummaryBill == "Email") {
                                    selectedPreferenceForSummaryBill = "1"
                                } else if (selectedPreferenceForSummaryBill == "Postal") {
                                    selectedPreferenceForSummaryBill = "2"
                                } else if (selectedPreferenceForSummaryBill == "Both") {
                                    selectedPreferenceForSummaryBill = "3"
                                }
                                const dataToSend = {
                                    summaryDispatch: selectedPreferenceForSummaryBill,
                                    itemizedRequired: "0",
                                    accountId: this.state.accountId,
                                    type: "UPDATE_BILLING_PREFERENCE",
                                    subtype: "summary"
                                };
                                this.setState({ isLoading: true })
                                Network.executeAxios("updateAccount", "POST", dataToSend, (response) => {
                                    var isSuccess = false;
                                    if (response && response.result_code && response.result_code === "0") {
                                        isSuccess = true;
                                    }

                                    if (isSuccess) {
                                        this.setState({
                                            isLoading: false
                                        })
                                        Swal.fire({
                                            title: this.props.locales.billingPreferencesSuccessText,
                                            text: '',
                                            type: '',
                                            timer: 2000,
                                            showCancelButton: false,
                                            confirmButtonText: 'ok',
                                        }).then((result) => {
                                            this.setState({ isLoading: true })
                                            this.initializeSettingsRoot();
                                        });
                                    } else {
                                        this.setState({ isLoading: false });
                                        Swal.fire(this.props.locales.billingPreferencesFailedText);
                                    }
                                })
                            } else {
                                if (selectedPreferenceForItemisedBill == "Email") {
                                    selectedPreferenceForItemisedBill = "1"
                                } else if (selectedPreferenceForItemisedBill == "Postal") {
                                    selectedPreferenceForItemisedBill = "2"
                                }
                                const dataToSend = {
                                    itemizedDispatch: selectedPreferenceForItemisedBill,
                                    itemizedRequired: "1",
                                    accountId: this.state.accountId,
                                    type: "UPDATE_BILLING_PREFERENCE",
                                    subtype: "itemized"
                                };
                                this.setState({ isLoading: true })
                                Network.executeAxios("updateAccount", "POST", dataToSend, (response) => {
                                    var isSuccess = false;
                                    if (response && response.result_code && response.result_code === "0") {
                                        isSuccess = true;
                                    }

                                    if (isSuccess) {
                                        this.setState({
                                            isLoading: false
                                        })
                                        Swal.fire({
                                            title: this.props.locales.billingPreferencesSuccessText,
                                            text: '',
                                            type: '',
                                            timer: 2000,
                                            showCancelButton: false,
                                            confirmButtonText: 'ok',
                                        }).then((result) => {
                                            this.setState({ isLoading: true })
                                            this.initializeSettingsRoot();
                                        });
                                    } else {
                                        this.setState({ isLoading: false });
                                        Swal.fire(this.props.locales.billingPreferencesFailedText);
                                    }
                                })
                            }
                        }
                    });
                    }
            } else if(this.state.type === "manageVasFeatures"){
                const dataToSend = {
                    "accountId": this.state.accountId,
                    "serviceId": this.props.cache.serviceInfo.serviceId,
                    "profileId": this.state.profileId,
                    "customerName": this.state.billingName,
                    "contactNum": this.state.contactNumber,
                    "serviceName": this.state.serviceName,
                    "callMeBackAllowed": this.state.callMeBackAllowed ? "true": "false",
                    "creditRequestAllowed": this.state.creditRequestAllowed ? "true": "false",
                    "balanceTransferAllowed": this.state.balanceTransferAllowed ? "true": "false"
                }
                this.setState({ isLoading: true })
                Network.executeAxios("updateServiceBasicDetails", "POST", dataToSend, (response) => {
                    var isSuccess = false;
                    if (response && response.result_code && response.result_code === "0") {
                        isSuccess = true;
                    }
                    this.setState({ isLoading: false, isSlderModalVisible: false });
                    if (isSuccess) {
                        Swal.fire({
                            title: this.props.locales.vasManagementSuccessSwalText,
                            text: '',
                            type: '',
                            timer: 2000,
                            showCancelButton: false,
                            confirmButtonText: 'ok',
                        }).then((result) => {
                           
                        });
                    } else {
                        Swal.fire(this.props.locales.vasManagementFailedSwalText);
                    }
                })
            }
        }
    }

    summaryBilltoggle = () => {
        this.setState(prevState => ({
            summaryBillDropdownOpen: !prevState.summaryBillDropdownOpen
        }));
    }

    handleInputValueChangeToggle = (fieldName, event) => {
          this.setState({
            [fieldName]: event.target.checked, // Sets the new value for the toggle
          });
      };

    itemisedBilltoggle = () => {
        this.setState(prevState => ({
            itemisedBillDropdownOpen: !prevState.itemisedBillDropdownOpen
        }));
    }

    summaryBillOptionsClicked(type, needConfirmation) {
        if (type === "postal") {
            if (needConfirmation) {
                Swal.fire({
                    title: this.props.locales.itemizedBillPrintingText,
                    text: '',
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                    cancelButtonText: this.props.locales.cancelButtonTextInSwal,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { this.summaryBillOptionsClicked("postal"); }
                });
            } else {
                this.setState({
                    selectedPreferenceForSummaryBill: "Postal",
                    isBillingPreferenceChanged: true,
                    // selectedPreferenceForItemisedBill: ""
                })
            }
        } else if (type === "email") {
            this.setState({
                selectedPreferenceForSummaryBill: "Email",
                isBillingPreferenceChanged: true,
                // selectedPreferenceForItemisedBill: ""
            })
        } else if (type === "both") {
            this.setState({
                selectedPreferenceForSummaryBill: "Both",
                isBillingPreferenceChanged: true,
                // selectedPreferenceForItemisedBill: ""
            })
        }
    }

    itemisedBillOptionsClicked(type, needConfirmation) {
        if (type === "postal") {
            if (needConfirmation) {
                Swal.fire({
                    title: this.props.locales.itemizedBillPrintingText,
                    text: '',
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                    cancelButtonText: this.props.locales.cancelButtonTextInSwal,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { this.itemisedBillOptionsClicked("postal"); }
                });
            } else {
                this.setState({
                    selectedPreferenceForItemisedBill: "Postal",
                    isBillingPreferenceChanged: true,
                    
                })
            }
        } else if (type === "email") {
            this.setState({
                selectedPreferenceForItemisedBill: "Email",
                isBillingPreferenceChanged: true,
               
            })
        }
    }
    
    manageBillingPreferenceRadio() {
        this.setState({
            isSummaryBillEnabled: !this.state.isSummaryBillEnabled
        })
    };

    handleContactNumberOnBlur = (name) => {
        var formatedData = GeneralUtils.formatPhoneNumberToUsFormat(this.state[name]);
        this.state[name] = formatedData;
        this.setState({ dummy: "dummy" });
    }


    toggleNotificationVoice = (val) => {
        Swal.fire({
            title: this.props.locales.SettingsCompChangeStatusSwal,
            text: '',
            type: '',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.value) {
                var status="true";
                if(this.state.notificationVoiceStatus) status = "false"
                    const dataToSend = {
                        status: status,
                        serviceId: this.props.cache.serviceInfo.serviceId
                    };
                  
                    this.setState({ isLoading: true })
                    Network.executeAxios("updateHlrStatus", "POST", dataToSend, (response) => {
                        var isSuccess = false;
                        if (response && response.statusCode && response.statusCode === "SC0000") {
                            isSuccess = true;
                        }

                        if (isSuccess) {
                            this.setState({
                                isLoading: false
                            })
                            Swal.fire({
                                title: this.props.locales.SettingsCompNotificationSuccessSwal,
                                text: '',
                                type: '',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                            }).then((result) => {
                                if (result.value) {
                                    this.setState({ isLoading: true })
                                    Network.executeAxios("fetchHlrStatus", "POST", {"serviceId": this.props.cache.serviceInfo.serviceId} , (HLRstatusResponse) => {
                                        this.manageHlrStatus(HLRstatusResponse,true);
                                    })
                                }
                            });
                        } else {
                            this.setState({ isLoading: false });
                            Swal.fire(this.props.locales.SettingsCompNotificationFailSwal);
                        }
                    });
            }
        })
    };


    userDetailsCard(){
        return(
            <div className='cardOuterContainer col-md-8 col-sm-12 p-4'>
                <div className='row justify-content-between'>
                    <div className='userDetailsTxt col-md-4 col-12'>User Details</div>
                    <div className='d-flex justify-content-end p-2 col-md-8 col-12'>
                    <div className='col-md-3 brandColorButton px-3 mx-2 text-center' style={{cursor: 'pointer'}} onClick={() => this.toggleNotificationVoice()}>{this.state.voiceMailStatusLabel}</div>
                        <div className='col-md-3 brandColorButton px-3 mx-2 text-center' style={{cursor: 'pointer'}} onClick={() => this.generalBtnClicked("changePassword")}>Change Password</div>

                        {this.props.cache.serviceInfo && this.props.cache.serviceInfo.connectionType != this.props.locales.connectionTypeForPrepaid ? 
                        <div className='col-md-3 brandColorButton px-3 mx-2 text-center' style={{cursor: 'pointer'}} onClick={() => this.generalBtnClicked("changeBillingPref")}>Billing Preference</div>
                        : null }

                    </div>
                </div>
                <div className='row justify-content-between  align-items-center py-3'>
                    <div className='d-flex align-items-center col-md-5 col-12'>
                        <img src={avatar} alt="" className="" width="87" height="81" />
                        <div className='p-0 m-0 pl-2'>
                            <div className='userDetailsName'>{this.state.accountId}</div>
                            <div className='accountName'>{this.state.accountFirstName}</div>
                        </div>
                       
                    </div>
                    <div className='row col-md-7 justify-content-end p-md-0 col-12'>
                        <div className='col-md-4 col-12'>
                            <div className='contactNumTxt' style={{fontWeight: 'bold'}}>{this.props.locales.phoneNumProfilePartSettings}</div>
                            <div className='d-flex'>
                                <div className='contactNumTxt'>{this.state.notificationSMSNumber}</div> &nbsp;
                                <div style={{cursor: 'pointer'}} onClick={() => this.generalBtnClicked("changeContactNum")}><FaPencilAlt /></div>
                            </div>
                        </div>
                        <div className='col-md-8 col-12'>
                            <div className='contactNumTxt'  style={{fontWeight: 'bold'}}>{this.props.locales.emailProfilePartSettings}</div>
                            <div className='d-flex'>
                                <div className='contactNumTxt'>{this.state.notificationEmailId}</div> &nbsp;
                                <div style={{cursor: 'pointer'}} onClick={() => this.generalBtnClicked("changeEmail")}><FaPencilAlt /></div>
                            </div>

                        </div>
                    </div>
                </div>
                <div>
                <div className='col-md-12 py-2 accountName'>Billing Address</div>
                <div className='col-md-12'>
                    <input name="changeBillingAddressLine1" type="text" disabled
                        className="form-control input_data addressTxtBox"
                        value={this.state.currentAddress1} onChange={(event) => this.handleInputValueChange(event)}
                        style={{ height: 40, fontSize: 14 }}
                        placeholder={this.props.locales.SettingsCompAddressLineLabel}
                    />
                    <div className="errorDesc clearErrorp"></div>
                </div>

                <div className='col-md-12 mt-2'>
                    <select className="form-control input_data addressTxtBox" disabled
                        value={this.state.currentAddress2} name="changeBillingAddressLine2"
                        onChange={(event) => this.handleInputValueChange(event)}>
                        <option value="" >{this.state.currentAddress2}</option> 
                        {this.state.villageDetails.map((item, key) => {
                            return (
                                <option key={key} value={item.value}>{item.value}</option>
                            )
                        })
                        }
                    </select>
                    <div className="errorDesc clearErrorp"></div>
                </div>

                <div className='col-md-12 d-flex justify-content-between mt-2'>
                    <div className='col-md-6 pl-0'>
                        <select className="form-control input_data addressTxtBox" disabled
                            value={this.state.currentCity} name="changeBillingCity"
                            onChange={(event) => this.handleInputValueChange(event)}>
                            <option value="" >{this.state.currentCity}</option> 
                            {this.state.parishDetails.map((item, key) => {
                                return (
                                    <option key={key} value={item.value}>{item.value}</option>
                                )
                            })
                            }
                        </select>
                        <div className="errorDesc clearErrorp"></div>
                    </div>
                    <div className='col-md-6 pr-0 pml-2' >
                        <select className="form-control input_data addressTxtBox" disabled
                            value={this.state.currentState} name="changeBillingState"
                            onChange={(event) => this.handleInputValueChange(event)}>
                            {/* <option value="" >{this.props.locales.SettingsCompStateChooseOption}</option> */}
                            {this.state.countryDetails.map((item, key) => {
                                var id = item.value;
                                if(this.state.currentState === item.id) id = item.id;
                                return (
                                    <option key={key} value={id}>{item.value}</option>
                                )
                            })
                            }
                        </select>
                        <div className="errorDesc clearErrorp"></div>
                    </div>
                    <div style={{cursor: 'pointer'}} onClick={() => this.generalBtnClicked("billingAddress")}><FaPencilAlt /></div>
                </div>
                { this.state.enableVasFeatures === "true" ? 
                <div className='col-md-12 mt-4'>
                    <div className='col-md-3 brandColorButton text-center py-2' style={{cursor: 'pointer'}} onClick={() => this.manageVasFeaturesClicked("manageVasFeatures")}>{this.props.locales.manageVasFeatureMainHeading}</div>
                </div>
                : null }
                
                </div>
                <SliderModal
                    isVisible={this.state.isSlderModalVisible}
                    uniqueModalReferenceId="troubleTickets"
                    mainHeading={this.state.sliderModalHeading}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1.5}
                    isResetButtonVisible={false}
                    contentPartBackgroundColor="#f7f7f7"
                    cancelButtonText="Close"
                    callback={this.sliderModalHandler}
                >
                      <div className="col-md-12 px-2" style={{ height: '100%' }} id="sliderContainer">
                        

                          {/* manage vas features */}
                        { this.state.type === "manageVasFeatures" ?
                        <div className="col-md-12 pt-3 px-4"  id="manageVasFeaturesContainer">
                            <div className="form-group col-md-12 p-0 mb-4">
                                <label className="formGroup_label_new">{this.props.locales.mainHeadingInCreditTransferModal}</label>
                                <div className="d-flex">
                                    <Toggle
                                        checked={this.state.balanceTransferAllowed}
                                        className=''
                                        icons={{checked: "ON", unchecked: "OFF"}}
                                        onChange={(event) => this.handleInputValueChangeToggle("balanceTransferAllowed", event)} 
                                    />
                                </div>
                                <div className="errorDesc"></div>
                            </div>
                            {this.props.cache.serviceInfo.connectionType && this.props.cache.serviceInfo.connectionType !== "1" ?
                            <>
                            <div className="form-group col-md-12 p-0 mb-4">
                                <label className="formGroup_label_new">{this.props.locales.mainHeadingInCallMeBackModal}</label>
                                <div className="d-flex">
                                    <Toggle
                                        checked={this.state.callMeBackAllowed}
                                        className=''
                                        icons={{checked: "ON", unchecked: "OFF"}}
                                        onChange={(event) => this.handleInputValueChangeToggle("callMeBackAllowed", event)} 
                                    />
                                </div>
                                <div className="errorDesc"></div>
                            </div>

                            <div className="form-group col-md-12 p-0 mb-4">
                                <label className="formGroup_label_new">{this.props.locales.mainHeadingInCreditRequestModal}</label>
                                <div className="d-flex">
                                    <Toggle
                                        checked={this.state.creditRequestAllowed}
                                        className=''
                                        icons={{checked: "ON", unchecked: "OFF"}}
                                        onChange={(event) => this.handleInputValueChangeToggle("creditRequestAllowed", event)} 
                                    />
                                </div>
                                <div className="errorDesc"></div>
                            </div>
                            </>
                            : null }
                        </div>
                       : null  }

                        {/* contact num change */}
                        { this.state.type === "changeContactNum" ?
                        <div className="col-md-12 pt-3"  id="changeSMSNumberContainer">
                            <div className="form-group col-md-12 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.enterPhoneNumInCallMeBackModal}</label>
                                <div className="d-flex">
                                <input name="changeNotificationSMSNumber" type="text"
                                    className="form-control input_data mandatoryFieldWithoutStyle formGroup_value_withoutStyle typeContactNum"
                                    value={this.state.changeNotificationSMSNumber}
                                    style={{ height: 40, borderLeft: "3px solid #EE3124", borderRight: 0, fontSize: 14 }}
                                    placeholder="Contact Number"
                                    onChange={(event) => {
                                        this.handleInputValueChange(event)
                                        this.handleContactNumberOnBlur("changeNotificationSMSNumber");
                                    }}
                                />
                                </div>
                                <div className="errorDesc"></div>
                            </div>
                        </div>
                       : null  }
                       

                        {/* email address change */}
                        { this.state.type === "changeEmail" ?
                        <div className="col-md-12 pt-3" id="changeEmailContainer">
                            <div className="form-group col-md-12 p-0 mb-1">
                                <label className="formGroup_label_new">Enter Email Address</label>
                                <div className="d-flex">
                                    <input type="text" name="changeNotificationEmailId" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeEmail"
                                        value={this.state.changeNotificationEmailId}
                                        onChange={(event) => {
                                            this.handleInputValueChange(event)
                                    
                                        }}
                                    />
                                </div>
                                <div className="errorDesc"></div>
                            </div>
                        </div>
                       : null  }

                          {/* billing address change */}
                          { this.state.type === "billingAddress" ?
                      
                               <div className="col-md-12  pt-3" id="billingAddressContainer">
                                            <div className="col-md-12 form-group">
                                                <label className="formGroup_label_new">{this.props.locales.SettingsCompAddressLineLabel}
                                                    <span style={{ paddingLeft: 5, cursor: 'pointer' }}>                                                            </span>
                                                </label>
                                                <div className="input-group">
                                                    <input name="changeBillingAddressLine1" type="text"
                                                        className="form-control input_data formGroup_value_withoutStyle validData"
                                                        value={this.state.changeBillingAddressLine1} onChange={(event) => this.handleInputValueChange(event)}
                                                        style={{ height: 40, fontSize: 14 }}
                                                        placeholder={this.props.locales.SettingsCompAddressLineLabel}
                                                    />
                                                </div>
                                                <div className="errorDesc clearErrorp"></div>
                                            </div>

                                            <div className="col-md-12 form-group">
                                                <label className="formGroup_label_new">{this.props.locales.SettingsCompAddressLine2Label}
                                                    <span style={{ paddingLeft: 5, cursor: 'pointer' }}>                                                            </span>
                                                </label>

                                                <select className="form-control formGroup_value input_data_"
                                                    value={this.state.changeBillingAddressLine2} name="changeBillingAddressLine2"
                                                    onChange={(event) => this.handleInputValueChange(event)}>
                                                    <option value={this.state.changeBillingAddressLine2} >{this.state.changeBillingAddressLine2}</option>
                                                    {this.state.villageDetails.map((item, key) => {
                                                        return (
                                                            <option key={key} value={item.value}>{item.value}</option>
                                                        )
                                                    })
                                                    }
                                                </select>

                                                <div className="errorDesc clearErrorp"></div>
                                            </div>

                                            <div className="col-md-12 form-group">
                                                <label className="formGroup_label_new">{this.props.locales.SettingsCompAddressLine3Label}
                                                    <span style={{ paddingLeft: 5, cursor: 'pointer' }}>                                                            </span>
                                                </label>
                                                <select className="form-control formGroup_value input_data_"
                                                    value={this.state.changeBillingCity} name="changeBillingCity"
                                                    onChange={(event) => this.handleInputValueChange(event)}>
                                                    <option value={this.state.changeBillingCity}>{this.state.changeBillingCity}</option>
                                                    {this.state.parishDetails.map((item, key) => {
                                                        return (
                                                            <option key={key} value={item.value}>{item.value}</option>
                                                        )
                                                    })
                                                    }
                                                </select>

                                                <div className="errorDesc clearErrorp"></div>
                                            </div>
                                            <div className="col-md-12 form-group">
                                                <label className="formGroup_label_new">{this.props.locales.SettingsCompAddressLine4Label}
                                                    <span style={{ paddingLeft: 5, cursor: 'pointer' }}>                                                            </span>
                                                </label>
                                                <select className="form-control formGroup_value input_data_"
                                                    value={this.state.changeBillingState} name="changeBillingState"
                                                    onChange={(event) => this.handleInputValueChange(event)}>
                                                    {/* <option value={this.state.changeBillingState} >{this.state.changeBillingState}</option> */}
                                                    {this.state.countryDetails.map((item, key) => {
                                                         var id = item.value;
                                                         if(this.state.currentState === item.id) id = item.id;
                                                        return (
                                                            <option key={key} value={id}>{item.value}</option>
                                                        )
                                                    })
                                                    }
                                                </select>


                                                <div className="errorDesc clearErrorp"></div>
                                            </div>
                                         
                                        </div>
                        
                       : null  }


                        {/* change Password */}
                        { this.state.type === "changePassword" ?
                           <div id="changePasswordModalContainer" className="col-md-12 row m-0 p-0">
                           <div className="col-md-12 row p-0 mx-auto">
                               <div className="col-md-12 form-group">
                                   <label className="formGroup_label_new">{this.props.locales.SettingsCompCurrentPswLabel}</label>
                                   <div className="input-group">
                                       <input type="password"
                                           className="form-control input_data mandatoryFieldWithoutStyle formGroup_value_withoutStyle typePassword"
                                           name="changePasswordModal_oldPassword"
                                           value={this.state.changePasswordModal_oldPassword} onChange={(event) => this.handleInputValueChange(event)}
                                           style={{ height: 40, borderLeft: "3px solid #EE3124", fontSize: 14 }}
                                           placeholder={this.props.locales.SettingsCompCurrentPswPlc}
                                       />
                                   </div>
                                   <div className="errorDesc clearErrorp"></div>
                               </div>
                               <div className="col-md-12 form-group">
                                   <label className="formGroup_label_new">{this.props.locales.typePasswordInChangePwdCollapseInsettings}
                                       <span style={{ paddingLeft: 5, cursor: 'pointer' }}>
                                           <button className="tooltipContainer" id="passwordInfoTooltip"><img src={infoIcon} alt="" /></button>
                                       </span>

                                       <Tooltip placement="top" isOpen={this.state.isPasswordInfoTooltipOpen} target="passwordInfoTooltip" toggle={() => { this.setState({ isPasswordInfoTooltipOpen: !this.state.isPasswordInfoTooltipOpen }) }}>
                                           {this.props.locales.SettingsCompCharecterToolTip}
                                       </Tooltip>

                                   </label>
                                   <div className="input-group">
                                       <input name="changePasswordModal_newPassword" type={this.state.newPasswordhidden ? "password" : "text"}
                                           className="form-control input_data mandatoryFieldWithoutStyle formGroup_value_withoutStyle typePassword"
                                           value={this.state.changePasswordModal_newPassword} onChange={(event) => this.handleInputValueChange(event)}
                                           style={{ height: 40, borderLeft: "3px solid #EE3124", borderRight: 0, fontSize: 14 }}
                                           placeholder={this.props.locales.SettingsCompPasswordPlc}
                                       />
                                       <div className="input-group-append">
                                           <span className="input-group-text" style={{ backgroundColor: '#ffffff', borderLeft: 0, color: '#d6d6d6' }} onClick={() => { this.setState({ newPasswordhidden: !this.state.newPasswordhidden }) }}>
                                               {this.state.newPasswordhidden ?
                                                   <img src={viewIcon} alt="" />
                                                   :
                                                   <img src={closeIcon} alt="" />
                                               }
                                           </span>
                                       </div>
                                   </div>
                                   <div className="errorDesc clearErrorp"></div>
                               </div>

                           </div>
                           <div className="col-md-12 row p-0 mx-auto">
                               <div className="col-md-12 form-group">
                                   <label className="formGroup_label_new">{this.props.locales.SettingsCompReTypePswLabel}</label>
                                   <div className="input-group">
                                       <input type="password"
                                           className="form-control input_data mandatoryFieldWithoutStyle formGroup_value_withoutStyle typePassword"
                                           name="changePasswordModal_confirmPassword"
                                           value={this.state.changePasswordModal_confirmPassword} onChange={(event) => this.handleInputValueChange(event)}
                                           style={{ height: 40, borderLeft: "3px solid #EE3124", fontSize: 14 }}
                                           placeholder={this.props.locales.SettingsCompReTypePswPlc}
                                       />
                                   </div>
                                   <div className="errorDesc clearErrorp"></div>
                               </div>
                             
                           </div>
                       </div>
                        : null  }


                         {/* billing pref change */}
                         { this.state.type === "changeBillingPref" ?
                                           <div className="col-md-12 p-0 mt-2" style={{ border: '1px solid rgba(179,179,179,0.3)', borderRadius: 6 }}>
                                           <div className="col-md-12 d-flex justify-content-between pb-2 py-1 align-items-center" style={{ minHeight: 50 }}>
                                               <div className="mr-sm-3 mr-0 col-md-10 custom-control custom-radio custom-control-inline" style={{ cursor: 'pointer' }} >
                                                   <input type="radio" id="summaryBillRadio" name="billingPreference" checked={this.state.isSummaryBillEnabled} className="custom-control-input" onChange={(event) => this.manageBillingPreferenceRadio()} />
                                                   <label className="col-md-12 p-0 custom-control-label" htmlFor="summaryBillRadio" style={{ cursor: 'pointer' }}>Summary Bill</label>
                                               </div>
                                               {/* <div className="my-auto">Summary Bill</div> */}
                                               {/* {this.state.isSummaryBillEnabled == true ? */}
                                                   <div className="col-md-2 pt-1 d-flex justify-content-end">
                                                       <Dropdown isOpen={this.state.summaryBillDropdownOpen} toggle={this.summaryBilltoggle} disabled={!this.state.isSummaryBillEnabled}>
                                                           <DropdownToggle caret style={{ color: "#407cca", backgroundColor: "transparent", border: "1px solid #407cca", borderRadius: 4, boxShadow: "unset", outline: "none", fontSize: 14, padding: "5px 10px 5px 10px", width: 80 }}>
                                                               {this.state.selectedPreferenceForSummaryBill ? this.state.selectedPreferenceForSummaryBill : "Choose"}
                                                           </DropdownToggle>
                                                           <DropdownMenu>
                                                               <DropdownItem style={{ boxShadow: "unset", outline: "none" }} onClick={() => { this.summaryBillOptionsClicked("email") }}>Email</DropdownItem>
                                                               <DropdownItem style={{ boxShadow: "unset", outline: "none" }} onClick={() => { this.summaryBillOptionsClicked("postal") }}>Postal</DropdownItem>
                                                               <DropdownItem style={{ boxShadow: "unset", outline: "none" }} onClick={() => { this.summaryBillOptionsClicked("both") }}>Both</DropdownItem>
                                                           </DropdownMenu>
                                                       </Dropdown>
                                                   </div>
                                                   {/* : null} */}
                                           </div>
                                           <div className="col-md-12 d-flex justify-content-between pb-2 py-1 align-items-center" style={{ minHeight: 50, borderTop: '1px solid rgba(179,179,179,0.3)' }}>
                                               <div className="mr-sm-3 mr-0 col-md-10 custom-control custom-radio custom-control-inline" style={{ cursor: 'pointer' }} >
                                                   <input type="radio" id="itemisedBillRadio" name="billingPreference" checked={this.state.isSummaryBillEnabled ? false : true} className="custom-control-input" onChange={(event) => this.manageBillingPreferenceRadio()} />
                                                   <label className="col-md-12 p-0 custom-control-label" htmlFor="itemisedBillRadio" style={{ cursor: 'pointer' }}>Itemised Bill</label>
                                               </div>
                                               {/* <div className="my-auto">Itemised Bill</div> */}
                                               {/* {this.state.isSummaryBillEnabled == true ? null : */}
                                                   <div className="col-md-2 pt-1 d-flex justify-content-end">
                                                       <Dropdown isOpen={this.state.itemisedBillDropdownOpen} toggle={this.itemisedBilltoggle} disabled={this.state.isSummaryBillEnabled}>
                                                           <DropdownToggle caret style={{ color: "#407cca", backgroundColor: "transparent", border: "1px solid #407cca", borderRadius: 4, boxShadow: "unset", outline: "none", fontSize: 14, padding: "5px 10px 5px 10px", width: 80 }}>
                                                               {this.state.selectedPreferenceForItemisedBill ? this.state.selectedPreferenceForItemisedBill : "Choose"}
                                                           </DropdownToggle>
                                                           <DropdownMenu>
                                                               <DropdownItem style={{ boxShadow: "unset", outline: "none" }} onClick={() => { this.itemisedBillOptionsClicked("email") }}>Email</DropdownItem>
                                                               <DropdownItem style={{ boxShadow: "unset", outline: "none" }} onClick={() => { this.itemisedBillOptionsClicked("postal", true) }}>Postal</DropdownItem>
                                                           </DropdownMenu>
                                                       </Dropdown>
                                                   </div>
                                               {/* } */}
                                           </div>
                                       </div>
                       : null  }


                    </div>
                </SliderModal>

                <Modal isOpen={this.state.isBillingAddressValidationModalVisible} size="md" centered>
                    <ModalBody style={{ height: '100%' }}>
                        <div style={{ zIndex: 1090, textAlign: 'center' }}>
                            <div className="pt-5" style={{ fontSize: 20, fontWeight: 'bold' }}>{this.props.locales.otpVerificationInsettingPart}</div>
                            <div className="px-3 py-2" style={{ width: '100%', height: '100%' }}>
                                <div className="col-md-12 px-3" style={{ fontSize: 15, color: '#58595B' }}>
                                    <div>{this.props.locales.otpSentToNumberInSettingPart}</div>
                                    <div className="pt-4" id="timer" style={{ fontWeight: 600, fontSize: 14 }}></div>
                                    <div className="col-md-12 pt-3 p-0" >
                                        <div className="col-md-6 formGroup_label_new mb-2 p-0" style={{ fontSize: 12, color: '#58595B' }}>{this.props.locales.enterOtpInPlaceholder}</div>
                                        <div className="col-md-12 form-group p-0">
                                            <input type="text" className="form-control formGroup_value " name="billingAddress_otp"
                                                style={{ boxShadow: 'unset', outline: 'none', border: '1px solid #ced4da' }}
                                                value={this.state.billingAddress_otp} onChange={(event) => this.handleInputValueChange(event)} />
                                            {this.state.isOtpTimerEnds && this.state.resendOtpClicked == false ?
                                                <div className="errorDesc pt-1 text-left">OTP expired. Please generate a new OTP and try again</div>
                                                : null}
                                            {this.state.resendOtpClicked ?
                                                <div className="errorDesc pt-1 text-left" style={{ color: '#36B07F' }}>New OTP sent successfully</div>
                                                : null}
                                        </div>

                                    </div>
                                </div>
                                <div className="pt-3 pb-2 buttonGroupInSettings">
                                    <Button className="cancelButton" style={{ width: '30%', height: 40, fontWeight: '500', marginRight: 35, border: '1px solid #0049A5', borderRadius: '4px', backgroundColor: '#ffffff', color: '#0049A5' }} onClick={() => { this.billingAddressModalClicked("cancel") }} >
                                        Cancel
                                    </Button>
                                    <Button className="saveButton" style={{ width: '30%', height: 40, backgroundColor: '#0049A5' }} onClick={() => { this.billingAddressModalClicked("submit") }} disabled={this.state.billingAddress_otp === "" || this.state.isOtpTimerEnds ? true : false} >
                                        {this.props.locales.confirmBtn}
                                    </Button>
                                </div>
                                {this.state.isOtpTimerEnds ?
                                    <div className="pb-4 pt-3" style={{ fontWeight: 600, color: '#0285CA', fontSize: 12, cursor: 'pointer' }} onClick={() => { this.billingAddressModalClicked("resendOtp") }}>{this.props.locales.resendOtpINSettingPart}</div>
                                    :
                                    <div className="pb-4 pt-3" style={{ fontWeight: 600, color: '#0285CA', fontSize: 12, opacity: '0.5' }}>{this.props.locales.resendOtpINSettingPart}</div>
                                }
                            </div>

                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload));
        },
    }
}

const AccountSettingComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountSettingComponent)

export default AccountSettingComponentContainer;
